const store = {
    namespaced: true,
    state() {
        return {
            viewedProducts: []
        };
    },
    getters: {
        getViewedProducts: state => {
            return state.viewedProducts;
        }
    },
    mutations: {
        addToViewedProducts: async (state, payload) => {
            const index = state.viewedProducts.findIndex(product => product.productId === payload.productId);

            if (index !== -1) {
                state.viewedProducts.splice(index, 1);
            }

            state.viewedProducts.unshift(payload);

            if (process.client) {
                localStorage.setItem('viewedProducts', JSON.stringify(state.viewedProducts));
            }
        },
        initializeViewedProducts: async state => {
            if (process.client) {
                const storedProducts = localStorage?.getItem('viewedProducts');

                if (storedProducts) {
                    state.viewedProducts = JSON.parse(storedProducts);
                }
            }
        }
    }
};

export default store;
